/**
 * The public page's paths (cmms docs/public-page-plan.md, 2.2; answer 10), in one place: app/auth.js, app/i18n.js and
 * the routes ask here. `/` and `/{am|sv|en}` are the deploy's default church; `/c/{code}` and `/{lang}/c/{code}` a
 * church by its code. Matched on the whole path, never a part of it: `/en` is the page, `/enrol` or `/app/en` is not.
 * No import: app/auth.js reads it before anything else loads.
 */
export const PUBLIC_LANGUAGES = ["am", "sv", "en"];
export const DEFAULT_LANGUAGE = "sv";

const ROOT = /^\/$/;
const LANGUAGE_ONLY = /^\/(am|sv|en)\/?$/;
const BY_CODE = /^(?:\/(am|sv|en))?\/c\/([^/]+)\/?$/;

/**
 * What a path asks of the public page - { language, code } with code null for the default church - or null when the
 * path is not the public page. `language` is null when the path names none.
 */
export function publicParishRoute(pathname) {
  const path = pathname || "";
  if (ROOT.test(path)) return { language: null, code: null };
  const only = LANGUAGE_ONLY.exec(path);
  if (only) return { language: only[1], code: null };
  const byCode = BY_CODE.exec(path);
  if (byCode) {
    let code;
    try {
      code = decodeURIComponent(byCode[2]);
    } catch (malformed) {
      return null;
    }
    return { language: byCode[1] || null, code };
  }
  return null;
}

export function isPublicParishPath(pathname) {
  return publicParishRoute(pathname) !== null;
}

/** The path of a church's page in a language: the default church's when `code` is null. */
export function publicParishPath(language, code) {
  return `/${language}${code ? `/c/${encodeURIComponent(code)}` : ""}`;
}

/** The calendar's view and month as the URL holds them (answer 10): the Ethiopian view unless it says greg. */
export function calendarFromSearch(search) {
  const params = new URLSearchParams(search || "");
  const view = params.get("view") === "greg" ? "greg" : "eth";
  const month = params.get("month");
  return { view, month: /^\d{4}-\d{2}$/.test(month || "") ? month : null };
}
